import { isNotNull } from "@repo/utils";
import type { PurchaseOrderComparison } from "./comparison/types.js";
import type { ApprovalThreshold, ThresholdTrigger, TriggeredApprovalThreshold } from "../../types.js";
import { evaluateThresholdsForPurchaseOrderComparison } from "./evaluateThreshold.js";
import { ApprovalThresholdSchema } from "../../z.js";

export function evaluatePOComparisonApproval(
    comparison: PurchaseOrderComparison,
    thresholds: ApprovalThreshold[],
): TriggeredApprovalThreshold[] {
    return convertToTriggeredApprovalThresholds(evaluateThresholdsForPurchaseOrderComparison(comparison, thresholds));
}

export function convertToTriggeredApprovalThresholds(triggers: ThresholdTrigger[]) {
    return triggers
        .map(t => {
            if (!t.beyond) {
                return null;
            }

            return {
                ...ApprovalThresholdSchema.parse(t.threshold),
                ...t,
            };
        })
        .filter(isNotNull);
}
